webpackJsonp([2],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_KristoffelScrollMagicController__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_KristoffelAssortmentController__ = __webpack_require__(106);



window.addEventListener('load', function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__controllers_KristoffelScrollMagicController__["a" /* KristoffelScrollMagicController */])();
  Object(__WEBPACK_IMPORTED_MODULE_1__controllers_KristoffelAssortmentController__["a" /* KristoffelAssortmentController */])();
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(enquire, $) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KristoffelScrollMagicController; });
/* unused harmony export horizontalScrollEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__ = __webpack_require__(15);



var horizontalScrollController = null;
var verticalScrollController = null;
var itemsController = null;

var KristoffelScrollMagicController = function KristoffelScrollMagicController() {

  enquire.register(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["b" /* queries */].desktop, {
    match: function match() {
      horizontalScrollEvent();
      animateItemsIn();
    },
    unmatch: function unmatch() {
      horizontalScrollController.destroy(true);
      itemsController.destroy(true);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["a" /* clearOffset */])($('.animate'), null);
    }
  });

  enquire.register(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["b" /* queries */].mobile, {
    match: function match() {
      verticalScrollEvent();
    },
    unmatch: function unmatch() {
      verticalScrollController.destroy(true);
    }
  });
};

var animateItemsIn = function animateItemsIn() {
  itemsController = new ScrollMagic.Controller({
    vertical: false,
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.9
    }
  });

  var $items = $('.animate');
  var $itemList = $('.animate-list');

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["c" /* setOffset */])($items, null);

  $itemList.each(function (i, el) {
    var $this = $(el);
    var offset = $this.attr('data-anim-offset');
    var $children = $this.find('.animate');

    Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["c" /* setOffset */])($children, offset);
  });

  $items.each(function (i, el) {
    var animScene = new ScrollMagic.Scene({
      triggerElement: el
      // duration: ($(window).width() / 3)
    }).setTween(el, 1.5, { transform: 'translateX(0)', opacity: '1' }).setClassToggle(el, "completed")
    // .addIndicators({name: 'anim', colorStart: 'blue', colorEnd: 'red', colorTrigger: 'green'})
    .addTo(itemsController);

    // $(window).on('window:resize', (e) => {
    //   animScene.duration($(window).width() / 3);
    // })

    animScene.tweenChanges(true);
  });
};

var horizontalScrollEvent = function horizontalScrollEvent() {
  horizontalScrollController = new ScrollMagic.Controller({
    vertical: false,
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.65
    }
  });

  var sections = $("#sidescroll section");

  // for (let i = 0; i < sections.length; i++) {
  sections.each(function (i, el) {
    var title = $(el).attr('data-title');
    var id = $(el).attr('id');
    var $video = $(el).find('video');

    var scrollScene = new ScrollMagic.Scene({
      triggerElement: el,
      duration: $(el).outerWidth(true)
    })
    // .setTween(el, {backgroundColor: "rgba(0,0,0,1)"})
    .on("enter", function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["d" /* titleAnimation */])(title);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["b" /* setActiveMenuItem */])(id);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["e" /* updateHash */])(id);
      // toggleVideoPlayBack(e.type, $video);
    })
    // .addIndicators({name: "section", colorStart: "blue", colorEnd: "red", colorTrigger: "green"})
    .addTo(horizontalScrollController);

    // Update duration on window resize
    $(window).on("window:resize", function (e) {
      scrollScene.duration($(el).outerWidth(true));
    });
  });
};

var verticalScrollEvent = function verticalScrollEvent() {
  verticalScrollController = new ScrollMagic.Controller({
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.35
    }
  });

  var sections = $("#sidescroll section");

  // for (let i = 0; i < sections.length; i++) {
  sections.each(function (i, el) {
    var title = $(el).attr('data-title');
    var id = $(el).attr('id');
    var $video = $(el).find('video');

    var scrollScene = new ScrollMagic.Scene({
      triggerElement: el,
      duration: $(el).height()
    })
    // .setTween(el, {backgroundColor: "rgba(0,0,0,1)"})
    .on("enter", function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["d" /* titleAnimation */])(title);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ScrollUtils__["b" /* setActiveMenuItem */])(id);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["e" /* updateHash */])(id);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_Utils__["d" /* toggleVideoPlayBack */])(e.type, $video);
    })

    // .addIndicators({name: "section", colorStart: "blue", colorEnd: "red", colorTrigger: "green"})
    .addTo(verticalScrollController);

    // Update duration on window resize
    $(window).on("window:resize", function (e) {
      scrollScene.duration($(el).height());
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(0)))

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, enquire) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KristoffelAssortmentController; });
var isDesktop = false;

var KristoffelAssortmentController = function KristoffelAssortmentController() {
  var $beers = $('.assortment-item');

  enquire.register('(min-width:1024px)', {
    match: function match() {
      isDesktop = true;
    }
  });

  enquire.register('(max-width:1023px)', {
    match: function match() {
      $('.assortment-list').mCustomScrollbar({
        axis: 'x',
        mouseWheel: false,
        autoDraggerLength: false,
        scrollbarPosition: 'outside',
        documentTouchScroll: true,
        scrollButtons: { enable: true }
      });

      isDesktop = false;
    },

    unmatch: function unmatch() {
      $('.assortment-list').mCustomScrollbar('destroy');
      isDesktop = true;
    }
  });

  $(window).on("window:resize", function (e) {
    enquire.register('(min-width:1024px)', {
      match: function match() {
        isDesktop = true;
      }
    });

    enquire.register('(max-width:1023px)', {
      match: function match() {
        isDesktop = false;
      },

      unmatch: function unmatch() {
        isDesktop = true;
      }
    });
  });

  // setTimeout(function() {
  //   const firstPosition = $('.assortment-list__item').first().position();
  //   positionSlider(firstPosition.left);
  // }, 2000);


  $beers.each(function (i, el) {
    var $beer = $(el);
    var $parent = $beer.parent();
    var $btn = $beer.find('.circle-btn');
    var beerType = $beer.attr('data-beer-type');
    var $slide = $('.assortment-slider-slide[data-beer-type="' + beerType + '"]').parent();

    buildSliderNav($beers.not($beer), $slide);

    $btn.on('click', function (e) {
      e.preventDefault();

      var position = $parent.position();

      if (!isDesktop) {
        position = 0;
        $('body').addClass('no-scroll');
        $('body').addClass('assortment-open');
      }

      window.currentBeerClicked = $(e.currentTarget);

      if (window.circleAnimComplete) {
        if ($('.assortment-slider').hasClass('show')) {
          deactivateSlider(function () {
            activateSlider($parent, $slide, position.left);
          });
        } else {
          activateSlider($parent, $slide, position.left);
        }
      }
    });
  });

  $('.close-slider, .main-nav__item').on('click', function (e) {
    deactivateSlider(function () {});
    window.allowScroll = true;

    if (!isDesktop) {
      $('body').removeClass('no-scroll');
      $('body').removeClass('assortment-open');
    }
  });

  var resized = void 0;
  $(window).resize(function () {
    clearTimeout(resized);
    resized = setTimeout(doneResizing, 500);
  });
};

var positionSlider = function positionSlider(position) {
  $('.assortment-slider').css({ 'left': position });
};

var showSlide = function showSlide(slide) {
  $('.assortment-slider__item').removeClass('show');

  setTimeout(function () {
    slide.addClass('show');
  }, 50);
};

var deactivateSlider = function deactivateSlider(callback) {
  $('.assortment-slider__item').removeClass('show');
  $('.assortment-slider').removeClass('show');
  $('.assortment-list__item').removeClass('is-active');
  window.activeSlider = false;
  window.currentBeerClicked = null;

  setTimeout(function () {
    callback();
  }, 500);
};

var activateSlider = function activateSlider($trigger, $slide, position) {
  var pos = 0;

  if (isDesktop) {
    pos = $trigger.offset().left;
  }

  $('.assortment-list__item').not($slide).removeClass('is-active');

  setTimeout(function () {
    $trigger.addClass('is-active');
  }, 1000);

  positionSlider(position);

  $('.assortment-slider').addClass('show');
  showSlide($slide);

  if (isDesktop) {
    $('html, body').animate({
      scrollLeft: pos
    }, 800);
  }

  window.scrollPos = pos;
  window.allowScroll = false;
  window.activeSlider = true;
};

var buildSliderNav = function buildSliderNav($otherBeers, $slide) {
  $slide.find('.assortment-slider-slide').append('<nav class="slider-nav"></nav>');

  $otherBeers.each(function (i, el) {
    var $beer = $(el);
    $slide.find('.slider-nav').append($beer.clone());
  });

  $slide.find('.slider-nav .assortment-item').on('click', function (e) {
    var beerType = $(e.currentTarget).attr('data-beer-type');
    var $slide = $('.assortment-slider-slide[data-beer-type="' + beerType + '"]').parent();

    showSlide($slide);
  });
};

var doneResizing = function doneResizing() {
  // do stuff
  if (window.activeSlider) {
    positionSlider(window.currentBeerClicked.parents('.assortment-list__item').position().left);
    $('html, body').animate({
      scrollLeft: window.currentBeerClicked.parents('.assortment-list__item').offset().left
    }, 800);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1)))

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setActiveMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return titleAnimation; });
var setActiveMenuItem = function setActiveMenuItem(id) {
  $('.main-nav__item').removeClass('active');
  $('.main-nav__item[data-target="' + id + '"]').addClass('active');
};

var setOffset = function setOffset(items, offset) {
  var transform = 150;
  items.each(function (i, el) {
    if (offset) {
      transform = 150 + i * offset;
    }
    $(el).css({ transform: 'translateX(' + transform + 'px)', opacity: 0 });
  });
};

var clearOffset = function clearOffset(items, offset) {
  items.css({ transform: '', opacity: '' });
};

var titleAnimation = function titleAnimation(title) {
  if (title) {
    var menuAnimation = function menuAnimation() {
      var element = menuLetterDiv[menuCount];
      if (element) {
        element.className += ' menu-letter-display';
        menuCount++;

        if (menuCount === menuLetterLength) {
          clearInterval(menuInterval);
        }
      } else {
        return;
      }
    };

    $('#pagetitle').empty('.menu-letter');

    var menuArr = [];

    menuArr.push(title.split(''));

    var menuLetters = menuArr[0];

    for (var i = 0; i < menuLetters.length; i++) {
      var menuLetter = document.createElement('span');
      menuLetter.className = 'menu-letter';
      menuLetter.innerHTML = menuLetters[i];
      $('#pagetitle').append(menuLetter);
    }

    var menuLetterDiv = document.getElementsByClassName('menu-letter');
    var menuLetterLength = menuLetterDiv.length;
    var menuCount = 0;

    var menuInterval = setInterval(menuAnimation, 25);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Modernizr) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return queries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleVideoPlayBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateHash; });
/* unused harmony export resetParentWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setParentWidth; });
/* unused harmony export setHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return objectFitter; });
var queries = {
  desktop: '(min-width:1024px)',
  // desktop: '(min-width:1024px) and (min-height:768px)',
  mobile: '(max-width:1023px)'
};

var toggleVideoPlayBack = function toggleVideoPlayBack(type, $video) {
  if ($video.length > 0) {
    if (type === 'enter') {
      $($video).get(0).play();
    }

    if (type === 'leave') {
      $($video).get(0).pause();
    }
  }
};

var updateHash = function updateHash(id) {
  var target = '#' + id;

  if (id === 'landing-default') {
    target = ' ';
  }

  history.replaceState(null, document.title, target);
};

var resetParentWidth = function resetParentWidth($container) {
  $container.css({ width: '' });
};

var setParentWidth = function setParentWidth($container, node) {
  var $section = $container.children(node);
  var totalWidth = 0;

  $section.each(function (i, el) {
    var $this = $(el);
    totalWidth += $this.outerWidth(true);
  });

  $container.width(Math.ceil(totalWidth));
};

var setHeight = function setHeight($container) {
  var windowHeight = $(window).innerHeight();
  $container.height(windowHeight);
};

var objectFitter = function objectFitter(parent, children) {

  if (!Modernizr.objectfit || /Edge/.test(navigator.userAgent) && children === 'video') {

    $(parent).each(function () {
      //set size
      var th = $(this).height(),
          //box height
      tw = $(this).width(),
          //box width
      im = $(this).children(children),
          //image
      ih = im.height(),
          //inital image height
      iw = im.width(); //initial image width
      if (ih > iw) {
        //if portrait
        im.css({ width: '100%', height: 'auto' }); //set width 100%
      } else {
        //if landscape
        im.css({ width: 'auto', height: '100%' }); //set height 100%
      }
      //set offset
      var nh = im.height(),
          //new image height
      nw = im.width(),
          //new image width
      hd = (nh - th) / 2,
          //half dif img/box height
      wd = (nw - tw) / 2; //half dif img/box width
      if (nh < nw) {
        //if portrait
        im.css({ marginLeft: '-' + wd + 'px', marginTop: 0 }); //offset left
      } else {
        //if landscape
        im.css({ marginTop: '-' + hd + 'px', marginLeft: 0 }); //offset top
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(5)))

/***/ })

},[104]);


// WEBPACK FOOTER //
// kristoffel/js/kristoffel.bundle.js